import {useCallback, useState} from "react";
import {User} from "../types";
import {getUserInfo} from "../api";

export const useRetrieveUserInfo = () => {
    const [isLoading, setIsLoading] = useState(false);

    const retrieveUserInfo = useCallback(async (id: string): Promise<User | null> => {
        let data = null;
        try {
            setIsLoading(true);
            data = await getUserInfo(id.trim().toLowerCase());
        } catch (error) {
            console.error("Something went wrong when retrieving user info.");
        }
        setIsLoading(false);
        return data;
    }, [])

    return {retrieveUserInfo, isLoading}
}
